// extracted by mini-css-extract-plugin
module.exports = {"custom_1":"custom_custom_1__1GYeH","custom_2":"custom_custom_2__2JCFw","custom_3":"custom_custom_3__NOMLY","custom_5":"custom_custom_5__NDLwv","custom_6":"custom_custom_6__592-J"};